export const isBucketListLoaded = (state) => {
    return state?.storageBuckets?.listLoaded;
};
